import { Badge } from '@/components/ui/badge'

interface AssistantTypeBadgeProps {
	type?: 'recognition' | 'uvp' | 'consultant' | 'notification'
	className?: string
}

const ASSISTANT_CONFIGS = {
	recognition: {
		label: '🌟 Reconocimiento',
		color: 'bg-brand-secondary/80 hover:bg-brand-secondary/80',
		description: 'Fase de autodescubrimiento',
	},
	uvp: {
		label: '💎 UVP Creator',
		color: 'bg-brand-secondary/80 hover:bg-brand-secondary/80',
		description: 'Creando tu propuesta de valor',
	},
	consultant: {
		label: '🎯 Consultor',
		color: 'bg-brand-secondary/80 hover:bg-brand-secondary/80',
		description: 'Asesoría estratégica',
	},
	notification: {
		label: '🔔 Notificación',
		color: 'bg-brand-secondary/80 hover:bg-brand-secondary/80',
		description: 'Mensaje del sistema',
	},
} as const

/**
 * Badge component to display the assistant type
 * Shows which agent responded to the user
 */
export const AssistantTypeBadge = ({ type, className = '' }: AssistantTypeBadgeProps) => {
	if (!type) {
		return null
	}

	const config = ASSISTANT_CONFIGS[type]
	if (!config) {
		return null
	}

	return (
		<Badge
			className={`${config.color} px-2 py-0.5 text-xs text-white ${className}`}
			title={config.description}
		>
			{config.label}
		</Badge>
	)
}
